import React, { useState } from "react";
import FormatList from "./format-list";
import Editor from "./editor/editor";

// Settings > Invoice Builder: pick a document type and format, then design it.
export default function InvoiceBuilder() {
  const [editing, setEditing] = useState(null); // { template, id, isDefault }
  const [lastType, setLastType] = useState(null);

  if (editing) {
    return (
      <Editor
        key={editing.id || editing.template.name}
        initialTemplate={editing.template}
        formatId={editing.id}
        isDefault={editing.isDefault}
        onBack={() => {
          setLastType(editing.template.docType);
          setEditing(null);
        }}
      />
    );
  }
  return <FormatList initialType={lastType} onOpen={setEditing} />;
}
